import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import HeroLinks from "/react4xp/components/shared/HeroLinks/HeroLinks";
import type { SectionMenu2PartProps } from "./SectionMenu2.d";

export const SectionMenu2Part = (props: ComponentProps<PartData>) => {
  const { topImageUrl, topImageSrc, title, menus, textUnderButtons, pageType } =
    (props.data as SectionMenu2PartProps) ?? {};

  return (
    <section className={`bg-forest${pageType ? `-${pageType}` : ""}`}>
      <div className="container">
        <a className="hero-article" href={topImageUrl}>
          <article>
            {topImageSrc && (
              <figure>
                <img src={topImageSrc} alt="" />
              </figure>
            )}
            {title && <h2>{title}</h2>}
          </article>
        </a>
        <HeroLinks heroLinks={menus} />
        {textUnderButtons && (
          <div
            className="text-large text-center"
            dangerouslySetInnerHTML={{ __html: textUnderButtons }}
          ></div>
        )}
      </div>
    </section>
  );
};

export default SectionMenu2Part;
